module.exports = __webpack_public_path__ + "static/media/hk.bb078da1.svg";